import React, { useRef, useEffect, useLayoutEffect, useState } from 'react';
import ProfileImageWithFallback from '../../../common/ProfileImageWithFallback';
import moment from 'moment';
import DisplayFileProper from '../FilesRelevent/DisplayFileProper';
import getTimeDifference from '../TimeDifference';
import CloudStorage from '../../../CloudStorage/CloudStorage';
import { useLocation } from 'react-router-dom';
import downloadFiles from '../FilesRelevent/DownloadFiles';
import { useChatPagination } from '../../../Context/ChatPaginationContext';

export default function ChatScrollBottom({ chatdatails, selectUser, messagesEndRef }) {
    let lastMessageDate = null;
    const chatContainerRef = useRef(null);
    const location = useLocation();
    const prevScrollHeightRef = useRef(0);
    const isLoadingMoreRef = useRef(false);
    const currentUserRef = useRef(null);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const hasScrolledToBottomRef = useRef(false);
console.log(chatdatails,"chatdatailschatdatails")
    const { setIndex, index } = useChatPagination();

    const handleDownlaodImage = async (message) => {
        const url = message.image;
        downloadFiles(url);
    };

    // ✅ Reverse messages so oldest are first, newest are last
    const messages = Array.isArray(chatdatails?.messages)
        ? [...chatdatails?.messages].reverse()
        : [];

    // Detect user change
    const userId = selectUser?.user_id || selectUser?.id;
    const hasUserChanged = currentUserRef.current !== userId;
    if (hasUserChanged) {
        currentUserRef.current = userId;
        setIsInitialLoad(true);
        hasScrolledToBottomRef.current = false;
    }

    // ✅ Function to scroll to bottom
    const scrollToBottom = (behavior = "auto") => {
        if (messagesEndRef?.current && chatContainerRef.current) {
            // Method 1: Direct scroll to bottom
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;

            // Method 2: Using scrollIntoView as fallback
            setTimeout(() => {
                messagesEndRef?.current?.scrollIntoView({
                    behavior: behavior,
                    block: "end"
                });
            }, 50);

            hasScrolledToBottomRef.current = true;
        }
    };

    // ✅ Initial scroll to bottom on first load or user change
    useEffect(() => {
        if (isInitialLoad && messages.length > 0 && chatContainerRef.current) {
            // Wait for DOM to be fully rendered
            const timer = setTimeout(() => {
                scrollToBottom("auto");
                setIsInitialLoad(false);
                prevScrollHeightRef.current = chatContainerRef.current.scrollHeight;
            }, 100);

            return () => clearTimeout(timer);
        }
    }, [isInitialLoad, messages.length]);

    // ✅ Handle new messages - scroll to bottom if near bottom OR if it's my own message
    useEffect(() => {
        if (!chatContainerRef.current || isLoadingMoreRef.current || isInitialLoad) return;

        const container = chatContainerRef.current;
        const lastMessage = messages[messages.length - 1];

        // Always scroll to bottom for my own messages
        const isMyMessage = lastMessage?.is_mine == 1;

        const isNearBottom =
            container.scrollHeight - container.scrollTop - container.clientHeight < 150;

        // If it's my message OR we're near bottom, scroll to bottom
        if (isMyMessage || isNearBottom) {
            requestAnimationFrame(() => {
                scrollToBottom("smooth");
            });
        }
    }, [messages.length, messages[messages.length - 1]?.id]); // Use id to trigger on actual new messages

    // ✅ Handle scroll to TOP - load more OLD messages
    useEffect(() => {
        const container = chatContainerRef.current;
        if (!container) return;

        let lastScrollTop = container.scrollTop;

        const handleScroll = () => {
            const currentScrollTop = container.scrollTop;
            const isScrollingUp = currentScrollTop < lastScrollTop;

            // Only trigger when scrolling UP and near top (within 50px)
            if (isScrollingUp && currentScrollTop < 50 && !isLoadingMoreRef.current) {
                isLoadingMoreRef.current = true;
                prevScrollHeightRef.current = container.scrollHeight;

                // Load more messages - increment index
                setIndex(prevIndex => prevIndex + 1);

                // Reset loading flag after a delay
                setTimeout(() => {
                    isLoadingMoreRef.current = false;
                }, 500);
            }

            lastScrollTop = currentScrollTop;
        };

        container.addEventListener('scroll', handleScroll);
        return () => container.removeEventListener('scroll', handleScroll);
    }, [setIndex]);

    // ✅ Maintain scroll position after loading more messages
    useEffect(() => {
        if (isLoadingMoreRef.current && chatContainerRef.current) {
            const container = chatContainerRef.current;
            const newScrollHeight = container.scrollHeight;
            const heightDifference = newScrollHeight - prevScrollHeightRef.current;

            // Maintain user's position by adjusting scroll
            container.scrollTop = heightDifference;
            prevScrollHeightRef.current = newScrollHeight;
        }
    }, [messages.length]);

    return (
        <div
            className="chatbox-row"
            ref={chatContainerRef}
            style={{
                overflowY: "auto",
                height: "100%",
                maxHeight: "calc(100vh - 200px)",
                display: "flex",
                flexDirection: "column",
                position: "relative"
            }}
        >
            {messages?.map((item, index) => {
                const messageDate = moment(item?.created_on).format("YYYY-MM-DD");
                const showDateSeparator = messageDate !== lastMessageDate;
                lastMessageDate = messageDate;

                return (
                    <div
                        className={`chatbox-content ${item?.is_mine == 1 ? "chat-right" : "chat-left"}`}
                        key={item?.id || index}
                    >
                        {showDateSeparator && (
                            <div className="chat-date-separator">
                                <span>{moment(item?.created_on).format("MMMM D, YYYY")}</span>
                            </div>
                        )}

                        {item?.is_mine != 1 && (
                            <ProfileImageWithFallback url={item?.profile_image} />
                        )}

                        <div className="chat-carla">
                            <h6>
                                {item?.is_mine == 1
                                    ? "You"
                                    : `${item?.name}`}
                            </h6>

                            <div>
                                {item?.image && (
                                    <>
                                        <img
                                            style={{ cursor: "pointer" }}
                                            onClick={() => handleDownlaodImage(item)}
                                            className="download-chat-img"
                                            src={`${CloudStorage.cloudurl}/Assets/Images/common/download-icon-black.png`}
                                            alt="Download"
                                        />
                                        <DisplayFileProper item={{ file: item?.image }} alt="" />
                                    </>
                                )}
                            </div>

                            <p>{item?.message}</p>
                            <span>{getTimeDifference(item?.created_on)}</span>
                        </div>
                    </div>
                );
            })}
            {/* ✅ Scroll anchor for bottom */}
            <div
                ref={messagesEndRef}
                style={{
                    height: "1px",
                    width: "100%",
                    flexShrink: 0
                }}
            />
        </div>
    );
}